import { CalendarStyle } from '@libs/components';
import Calendar from 'react-calendar';
import styled from 'styled-components';

export const CustomCalendar = styled(Calendar)`
  ${CalendarStyle};
`;
